import { useSEO } from "@/components/SEO";
import { Eyebrow, Masked } from "@/components/bits";

const CONTENT = {
    privacy: {
        title: "Privacy Policy",
        lead: "Vantera respects the privacy of every visitor. This policy explains, in plain terms, what information this website collects and how it is used.",
        sections: [
            ["Information We Collect", "When you request an Executive Review or a Business X-Ray, we collect the information you provide through the form: your name, work contact details, company information, and the business challenge you describe. We also collect standard, aggregate analytics about how the site is used."],
            ["How We Use It", "The information you submit is used solely to respond to your inquiry, prepare for the Executive Review, and communicate with you about Vantera's services. We do not sell your personal information to third parties."],
            ["Data Storage", "Form submissions are stored securely in Vantera's systems and retained only as long as needed to process your inquiry and maintain a record of our communications with you."],
            ["Your Choices", "You may request access to, correction of, or deletion of the personal information you have submitted at any time by contacting us through this website."],
            ["Changes", "If this policy changes, the updated version will be posted on this page."],
        ],
    },
    terms: {
        title: "Terms of Use",
        lead: "By using this website, you agree to these terms. Please read them.",
        sections: [
            ["Use of This Website", "This website is provided for informational purposes about Vantera's services. You may browse, download, and print materials from the site for your own business reference, provided you do not modify or republish them."],
            ["No Professional Advice", "Content on this website, including any illustrative dashboards, figures, or opportunity analyses, is provided for general information only. It does not constitute financial, legal, or professional advice, and it does not guarantee any specific business outcome, savings, or result."],
            ["Intellectual Property", "All content, branding, visualizations, and materials on this website are the property of Vantera or its licensors and may not be reproduced without permission."],
            ["Limitation of Liability", "Vantera provides this website 'as is' without warranties of any kind. To the fullest extent permitted by law, Vantera is not liable for any damages arising from the use of this website."],
            ["Contact", "Questions about these terms may be sent to Vantera through the contact page of this website."],
        ],
    },
};

const Legal = ({ page = "privacy" }) => {
    const c = CONTENT[page];
    useSEO({ title: `${c.title} | Vantera`, description: c.lead, path: page === "privacy" ? "/privacy" : "/terms" });

    return (
        <section className="pt-32 pb-24 sm:pt-40 sm:pb-32" data-testid={`legal-${page}`}>
            <div className="container-x max-w-3xl">
                <Eyebrow>Legal</Eyebrow>
                <Masked inview lines={[c.title]} as="h1" className="mt-7 font-display text-4xl font-extrabold tracking-tightest sm:text-6xl" />
                <p className="mt-6 text-lg leading-relaxed text-slategray">{c.lead}</p>
                <div className="mt-14 space-y-12">
                    {c.sections.map(([h, body], i) => (
                        <div key={h} data-testid={`legal-${page}-section-${i + 1}`}>
                            <h2 className="font-display text-xl font-extrabold tracking-tight sm:text-2xl">{h}</h2>
                            <p className="mt-3 text-[16.5px] leading-relaxed text-slategray">{body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Legal;